import { useTranslation } from 'react-i18next';

export default function CtaBanner() {
  const { t } = useTranslation();

  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 bg-amber-700 relative overflow-hidden">
      <div className="relative max-w-3xl mx-auto text-center">
        <p className="text-[10px] sm:text-xs font-semibold tracking-wider sm:tracking-widest uppercase text-amber-200 mb-4 sm:mb-5">
          {t('ctaKicker')}
        </p>
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-white mb-4 sm:mb-6 leading-tight">
          {t('ctaTitle')}
        </h2>
        <p className="text-base sm:text-lg text-amber-100 leading-relaxed mb-8 sm:mb-10 max-w-2xl mx-auto">
          {t('ctaText')}
        </p>
        <button
          className="d21-trigger-ibe inline-block bg-white text-amber-700 px-8 sm:px-10 py-3.5 sm:py-4 rounded-md text-sm font-semibold hover:bg-amber-50 transition-colors whitespace-nowrap cursor-pointer shadow-lg"
        >
          {t('ctaButton')}
        </button>
      </div>
    </section>
  );
}
